import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';

const NativeDatePicker = ({
    className,
    name,
    value,
    handleDateChange,
    disabled,
    disableFuture = true,
    classes,
    sx,
    ...rest
}) => {
    const handleChange = useCallback(
        newValue => {
            handleDateChange(moment(newValue).clone().local());
        },
        [handleDateChange]
    );

    return (
        <DatePicker
            disabled={disabled}
            disableFuture={disableFuture}
            name={name}
            value={value}
            onChange={handleChange}
            format="DD/MM/yyyy"
            margin="none"
            OpenPickerButtonProps={{ size: 'small', disableRipple: true }}
            renderInput={params => (
                <TextField
                    {...params}
                    classes={{ root: className, ...classes }}
                    className={className}
                    sx={theme => ({
                        '& .MuiOutlinedInput-root': { paddingRight: '14px' },
                        '& .MuiInput-underline:after': {
                            display: 'none',
                        },
                        '& .MuiInput-underline:before': {
                            display: 'none',
                        },
                        '& .MuiInput-input': {
                            padding: 0,
                        },
                        ...(typeof sx === 'function' ? sx(theme) : sx),
                    })}
                    variant="standard"
                    error={false} // override error status
                    inputProps={{
                        ...params.inputProps,
                        placeholder: 'JJ/MM/AAAA',
                    }}
                />
            )}
            emptyLabel="-"
            {...rest}
        />
    );
};

NativeDatePicker.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    handleDateChange: PropTypes.func,
    disabled: PropTypes.bool,
    disableFuture: PropTypes.bool,
    classes: PropTypes.object,
};

export default NativeDatePicker;
